import { Schema } from "lego-gui-lib/lib";
import { t } from "../../../core/i18n/i18n";
import { Auth } from "../../../core/model/auth";
import { api, mainStore } from "../../../core/mainStore";
import { RemoteChildDataSource } from "lego-gui-lib/lib/dataAccess/RemoteChildDataSource";
import { createContext } from "react";
import { WebUserRoleCustomerOnlyFk } from "../../webUserRole/schema";
import { CustomerFK } from "../../customer/schema";

export const WebUserAccessSchema = new Schema({
  fields: [
    {
      name: "customerRef",
      type: CustomerFK,
      title: t("hns:customer:domain"),
      readonly: true
    },
    {
      name: "webRoleRef",
      type: WebUserRoleCustomerOnlyFk,
      title: t("hns:auth:role")
    }
  ],
  primaryKey: ["id"],
  security: {
    readableRole: Auth.Roles.ANY_ADMIN,
    editableRole: Auth.Roles.ADMIN
  }
});

mainStore.webUserAccess = RemoteChildDataSource.create({
  api: api,
  parent: mainStore.webUser.oneDataSource,
  name: "webUserAccess",
  schema: WebUserAccessSchema,
  url: "/webAccess",
  commons: mainStore.commons
});

export const webUserAccessContext = createContext(mainStore.webUserAccess);
